// extracted by mini-css-extract-plugin
module.exports = {"layout":"Container_layout__P8mjd","cards":"Container_cards___89g2","badge":"Container_badge__GTP_4"};